import * as THREE from 'three';
// import { makeNoise4D } from 'open-simplex-noise';
import { material1, material2, material3 } from './helpers/texturesAndGeometries';

class NoisyCircleMesh {
  constructor(radius, segments) {
    // Create a noise function with the current timestamp as the seed
    // this.noise = makeNoise4D(Date.now());
    this.noise;
    // Geometry


    this.geometry = new THREE.CircleGeometry(radius, segments);
    this.strength = 0;

    // Store original position data
    this.positionData = [];
    const v3 = new THREE.Vector3();
    for (let i = 0; i < this.geometry.attributes.position.count; i++) {
      v3.fromBufferAttribute(this.geometry.attributes.position, i);
      this.positionData.push(v3.clone());
    }

    // Material

    // Mesh
    this.mesh = new THREE.Mesh(this.geometry, material2);
  }

  // Method to update the mesh with noise
  update(t) {
    for (let i = 0; i < this.positionData.length; i++) {
      let p = this.positionData[i];
      let noiseValue = this.noise(p.x * 1 * this.strength, p.y * 1 * this.strength, 0, t * 0.05 * this.strength);
      // let newPos = p.clone().addScaledVector(p.normalize(), noiseValue * 0.15);
      let newPos = p.clone().addScaledVector(p, noiseValue * 0.15);
      this.geometry.attributes.position.setXYZ(i, newPos.x, newPos.y, p.z);
    }
    this.geometry.computeVertexNormals();
    this.geometry.attributes.position.needsUpdate = true;
  }

  // Method to get the mesh
  getMesh() {
    return this.mesh;
  }
  setMood(id) {
    switch (Number(id)) {
      case 1:
        this.mesh.material = material1;
        break;
      case 2:
        this.mesh.material = material2;
        break;
      case 3:
        this.mesh.material = material3;
        break;
    }
  }
}

export default NoisyCircleMesh;
